import { Component, Input, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MatLegacyMenu as MatMenu, MatLegacyMenuTrigger as MatMenuTrigger } from '@angular/material/legacy-menu';
import { Features } from '@app/core/user-permissions/user-permissions.model';
import { UserPermissionsService } from '@app/core/user-permissions/user-permissions.service';
import { TaskEditModalService } from '@app/features/operations';
import { Reservation, Task } from '@app/shared/interfaces';
import { TasksService } from '@app/shared/services/tasks/tasks.service';
import { Logger } from '@utils';

@Component({
  standalone: false,
  selector: 'sbnb-task-list',
  templateUrl: './task-list.component.html',
  styleUrls: ['./task-list.component.scss'],
})
export class TaskListComponent implements OnInit {
  selectedTask: Task;
  loading: boolean;
  mainMenuOpen = false;

  perms$ = this.userPermissionsService;
  Features = Features;
  @ViewChildren(MatMenuTrigger) menuTriggers: QueryList<MatMenuTrigger>;
  @ViewChild('mainAssignMenuTrigger', { static: false }) mainAssignMenuTrigger: MatMenuTrigger;
  @ViewChild('assignMenuTrigger', { static: false }) assignMenuTrigger: MatMenuTrigger;
  @ViewChild('mainAssignMenu', { static: false }) mainAssignMenu: MatMenu;
  @ViewChild('assignMenu', { static: false }) assignMenu: MatMenu;

  @Input() threadUuid: string;
  @Input() lite: boolean;
  @Input() reservation: Reservation;
  @Input() tasks: Task[] = []; // Alternatively, provide your own tasks

  constructor(
    private readonly taskService: TasksService,
    private readonly userPermissionsService: UserPermissionsService,
    private readonly taskEditModalService: TaskEditModalService
  ) {}

  ngOnInit() {
    if (!this.tasks || this.tasks.length === 0) {
      this.getTasks();
    }
  }

  getTasks() {
    this.loading = true;
    this.taskService.getTasksForThread(this.threadUuid).subscribe((res) => {
      this.tasks = res;
      this.loading = false;
    });
  }

  taskAssigned(newTaskData) {
    if (newTaskData.name) {
      const index = this.tasks.findIndex((x) => x.name === newTaskData.name);

      if (index > -1) {
        this.tasks[index] = newTaskData;
      }
    }
  }

  taskCreated(newTaskData) {
    this.tasks.push(newTaskData);
  }

  removeTask(uuid: string) {
    const index = this.tasks.findIndex((x) => x.uuid === uuid);

    if (index > -1) {
      this.tasks.splice(index, 1);
    }
  }

  closeMainMenu() {
    this.mainMenuOpen = false;
    // Close any open menu triggers
    if (this.menuTriggers) {
      this.menuTriggers.forEach((trigger) => {
        if (trigger.menuOpen) {
          trigger.closeMenu();
        }
      });
    }
  }

  openMarketplaceTask(task: Task) {
    this.taskEditModalService
      .open({ taskUuid: task.uuid })
      .afterClosed()
      .subscribe((result) => {
        if (!result) {
          return;
        }

        if (result?.action === 'updated') {
          Logger.debug('Task updated', result.task);
          this.taskAssigned(result.task);
        }
        if (result?.action === 'deleted') {
          Logger.debug('Task deleted', result.taskUuid);
          this.removeTask(result.taskUuid);
        }
      });
  }
}
